import Vue from 'vue'
import Vuex from 'vuex'
import errorLog from './modules/errorLog'
import baseData from './modules/baseData'
import getters from './getters'
import createLogger from 'vuex/dist/logger'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    errorLog,
    baseData
  },
  getters,
  plugins: [createLogger()]
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js